export const formatName = (name: string | undefined): string | undefined => {
  if (!name) return

  const nameUser = name.split('.')

  return nameUser.length > 1 ? `${nameUser[0]} ${nameUser[1]}` : nameUser[0]
}
